<script>
  import TextFit from "../TextFit.svelte"
  import CharacterHighlighter from "./CharacterHighlighter.svelte"

  import * as contexts from "./contexts.json"

  export let glyph
  let containerWidth, containerHeight

  $: glyphContexts = (contexts[glyph.unicode_decimal] || [])
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)
  $: context = glyphContexts[0]
  $: textFitState = context + glyph.character
</script>

<div class="root">
  <div
    class="container"
    bind:clientWidth={containerWidth}
    bind:clientHeight={containerHeight}
  >
    <TextFit
      {containerWidth}
      {containerHeight}
      maxFontSize={160}
      update={textFitState}
    >
      <CharacterHighlighter word={context} character={glyph.character} />
    </TextFit>
  </div>
</div>

<style>
  .root {
    max-height: 100%;
    padding-top: calc(var(--vh, 1vh) * 4);
    padding-bottom: calc(var(--vh, 1vh) * 4);
    padding-left: calc(var(--vh, 1vh) * 8);
    padding-right: calc(var(--vh, 1vh) * 8);
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    text-align: center;
  }

  .container {
    font-family: var(--family);
    width: 100%;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: stretch;
    align-items: center;
    text-align: center;
  }
</style>
